// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs-module--breadcrumbs--3f-n9","home":"breadcrumbs-module--home--tKVDe"};